

import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload';
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import underscore from 'underscore';
import asdasd from './assets/loading.gif';

window._ = underscore;
window.underscore = underscore;

Vue.use(LoadingPlugin)

Vue.use(VueLazyload, {
preLoad: 1.3,
error: 'dist/error.png',
loading: asdasd,
attempt: 1
})

Vue.directive('title', {
inserted: function (el, binding) {
document.title = el.dataset.title
}
})



Vue.config.productionTip = false;

import '@/permission';


/* eslint-disable no-new */
window.vm = new Vue({
router: router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js